import React, { FC, useState } from 'react';
import { IFields, TypeStatisticsEnum, IProps } from './types';
import {
  AdvertisersStatistics, CampaignsStatistics, EventStatistics, ExportStatistics, ImportStatistics, JobsStatistics,
  PublishersStatistics, ReportStatistics, TQMStatistics,
} from './TypesStatistics/TypesStatistics';

const CardStatistics: FC<IProps> = ({
  filterByDate, type, isRemove, handleRemove, id, field, handleEdit, isCompare, compareDate, color,
}) => {
  const [fields, setFields] = useState<IFields>({});

  return (
    <>
      {(() => {
        switch (type) {
          case TypeStatisticsEnum.EVENTS: return (
            <EventStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              isCompare={isCompare}
              compareDate={compareDate}
              color={color}
            />
          );
          case TypeStatisticsEnum.REPORTS: return (
            <ReportStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              isCompare={isCompare}
              compareDate={compareDate}
              color={color}
            />
          );
          case TypeStatisticsEnum.ADVERTISERS: return (
            <AdvertisersStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.PUBLISHERS: return (
            <PublishersStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.JOBS: return (
            <JobsStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.CAMPAIGNS: return (
            <CampaignsStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.TQM: return (
            <TQMStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.IMPORT: return (
            <ImportStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          case TypeStatisticsEnum.EXPORT: return (
            <ExportStatistics
              filterByDate={filterByDate}
              fields={fields}
              setFields={setFields}
              isRemove={isRemove}
              handleRemove={handleRemove}
              handleEdit={handleEdit}
              id={id}
              field={field}
              color={color}
            />
          );
          default: return <h1>No statistics match</h1>;
        }
      })()}
    </>
  );
};

export default CardStatistics;
